var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-field",
    {
      attrs: {
        error: _vm.errors.has("language"),
        "error-label": _vm.errors.first("language"),
        label: _vm.labelWidth ? _vm.$t("language") : "",
        labelWidth: _vm.labelWidth
      }
    },
    [
      _c("q-select", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate.disable",
            value: "required|locale",
            expression: "'required|locale'",
            modifiers: { disable: true }
          }
        ],
        attrs: {
          value: _vm.value,
          "data-vv-name": "language",
          placeholder: _vm.$t("language"),
          options: _vm.languageOptions
        },
        on: { input: _vm._emit }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }